import CertifyContainer from '../../containers/auth/CertifyContainer'

const CertifyPage = () => {
  return <CertifyContainer />
}

export default CertifyPage
